import LocalStorageManager from './../../utils/LocalStorageManager'
import UserActions from './actions'

export default class UserMiddleware {
  static setUser () {
    return (dispatch) => {
      const user = LocalStorageManager.getUser()
      dispatch(UserActions.setUser(user))
    }
  }

  static clearUser () {
    return (dispatch) => {
      dispatch(UserActions.removeUser())
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/user/middleware.js